import styled from 'styled-components';
import { CheckoutPreOrderStyled } from '../CheckoutPreOrderStyled';
import { rem } from 'polished';

export const CheckoutPreOrderStyledAP = styled(CheckoutPreOrderStyled)`
    .consent-checkbox {
        margin-top: ${rem(63)};
        margin-bottom: ${rem(24)};
    }

    .submitButton {
        button {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            &:disabled {
                background: ${({ theme }) => theme.colors.grey12};
                opacity: 1;
            }
        }
    }

    .subTitle p {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        line-height: ${rem(18)};
    }
`;
